import React, {FC} from "react";
import {IconButton, Typography} from "@material-ui/core";
import {ChevronLeft, ChevronRight} from "@material-ui/icons";
import {format, getMonth, getYear} from "date-fns";
import {de} from "date-fns/locale";

export interface MonthPaginationProps {
    onChange: (newFirstOfSelectedMonth: Date) => void;
    firstOfSelectedMonth: Date;
    side?: "left" | "right";
}

export const MonthPagination: FC<MonthPaginationProps> = ({onChange, firstOfSelectedMonth, side = "right"}) => {

    const selectedMonth = getMonth(firstOfSelectedMonth);
    const selectedYear = getYear(firstOfSelectedMonth);

    return (
        <div style={{display: 'flex', alignItems: 'center', justifyContent:  side === "right" ? 'flex-end' : "flex- start"}}>
            <IconButton onClick={() => {
                if (selectedMonth - 1 < 0) {
                    onChange(new Date(selectedYear - 1, 11))
                } else {
                    onChange(new Date(selectedYear, selectedMonth - 1));
                }
            }}>
                <ChevronLeft/>
            </IconButton>
            <Typography color="textSecondary">{
                format(
                    firstOfSelectedMonth,
                    'MMMM, yyyy',
                    {locale: de}
                )}
            </Typography>
            <IconButton onClick={() => {
                if (selectedMonth + 1 > 11) {
                    onChange(new Date(selectedYear + 1, 0))
                } else {
                    onChange(new Date(selectedYear, selectedMonth + 1));
                }

            }}>
                <ChevronRight/>
            </IconButton>
        </div>
    )
}